/** Safe to log — no URL, path, body, headers or PII. */
export class AuthSessionCancelledError extends Error {
  readonly name = 'AuthSessionCancelledError';
  readonly cancelled = true;

  constructor() {
    super('auth_session_cancelled');
  }
}

export function isAuthSessionCancelled(error: unknown): boolean {
  return !!(error && typeof error === 'object' && (error as { cancelled?: boolean }).cancelled);
}

export type AuthFailureKind = 'session_dead' | 'transient' | 'version_stale';

export class AuthRequestError extends Error {
  readonly name = 'AuthRequestError';
  readonly status?: number;
  readonly pathClass?: string;
  readonly correlationId?: string;
  readonly kind?: AuthFailureKind;
  code?: string;

  constructor(fields: {
    status?: number;
    pathClass?: string;
    correlationId?: string;
    kind?: AuthFailureKind;
    message?: string;
    code?: string;
  }) {
    super(fields.message || 'auth_request_error');
    this.status = fields.status;
    this.pathClass = fields.pathClass;
    this.correlationId = fields.correlationId;
    this.kind = fields.kind;
    this.code = fields.code;
  }
}
